<template>
  <div class="week-container">
    <tool-bar
      v-model:selectedCycleId="selectedQuarterCycleId"
      v-model:allOrCurrent="allOrCurrent"
      :user-id="userId"
    />
    <my-table
      :table-id="tableId"
      :columns="columns"
      :data="data"
      :loading="loading"
    >
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.indexOf('week') >= 0">
          <div
            class="content"
            @click="clickHandler(record, column)"
          >
            <div v-html="parseContent(column, record)" />
            <div
              v-if="commentVisible(record, column)"
              class="comment-button"
              @click.stop="editCommentHandler(record, column)"
            >
              {{ t('weekly.checkComment') }}
            </div>
          </div>
        </template>
        <template v-else-if="column === 'objectiveDescription'">
          <div
            class="content"
            @click="editObjectiveDescHander(record, text)"
          >
            <div v-html="text && replaceStr2Html(JSON.parse(text)[selectedQuarterCycleId-1] || '')" />
          </div>
        </template>
        <template v-else-if="column === 'progress'">
          <span>{{ text }}%</span>
        </template>
        <template v-else>
          <div v-html="text" />
        </template>
      </template>
    </my-table>
    <edit-week
      v-model:visible="editWeekVisible"
      :week-data="weekData"
      :key-result="keyResult"
      :update-week-data="updateWeekData"
    />
    <edit-objective-desc
      v-model:visible="editObjectiveDescVisible"
      :objective-desc="objectiveDesc"
      :objective-id="objectiveId"
      :update-objective-description="updateObjectiveDescription"
    />
    <edit-comment
      v-model:visible="editCommentVisible"
      :weekly-detail="weeklyDetail"
    />
  </div>
</template>
<script setup>
import ToolBar from '@/views/OkrWeek/ToolBar.vue'
import MyTable from '@/components/MyTable/index'
import EditWeek from './EditWeek/index.vue'
import EditObjectiveDesc from './EditObjectiveDesc/index.vue'
import EditComment from './EditComment/index.vue'
import { replaceStr2Html } from '@/utils/line-break'
import useOkr from './useOkr'
import useTable from './useTable.js'
import useTime from './useTime'
import { ref, computed, toRefs } from 'vue'
import dayjs from 'dayjs'
import moment from 'moment'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  userId: {
    type: [Number, String],
    default: undefined
  }
})
const { userId } = toRefs(props)
const selectedQuarterCycleId = ref(dayjs().quarter())
const { startDayOfQuarter, lastDayOfQuarter, firstFriday, lastFriday } = useTime(selectedQuarterCycleId)
// const { startDayOfQuarter, lastDayOfQuarter } = useTime(selectedQuarterCycleId)
const { columns } = useTable(firstFriday, lastFriday)
const allOrCurrent = ref('ALL')
const { data, loading, okrlistId } = useOkr(props, startDayOfQuarter, lastDayOfQuarter, allOrCurrent)

// 生成tableId
const store = useStore()
const tableId = computed(() => {
  const user = userId.value || 'self'
  const year = (store.state.yearCycles[store.state.activeYearIndex] || [])[0]?.name
  return `${user}-${year}`
})

// 点击周报
const clickHandler = (record, column) => {
  if (!props.userId) {
    editWeekly(record, column)
  }
}

// 是否可以查看评论
const commentVisible = (item, column) => {
  const week = column.split(':')[1]
  return column.indexOf('remarks') >= 0 && item.week[week]
}

// 编辑周报
const editWeekVisible = ref(false)
const weekData = ref(undefined)
const keyResult = ref(undefined)
const updateWeekData = ref(undefined)
const editWeekly = (item, column) => {
  const week = column.split(':')[1]
  keyResult.value = item
  weekData.value = item.week[week] || {
    objectiveId: item.objectiveId,
    keyresultId: item.krId,
    okrlistId: okrlistId.value,
    weekDate: week
  }
  updateWeekData.value = (val, kr) => {
    item.week[week] = val
    if (!kr) {
      return
    }
    item.startDay = kr.start_day
      ? moment.unix(kr.start_day).format('YYYY-MM-DD')
      : undefined
    item.endDay = kr.finish_day
      ? moment.unix(kr.finish_day).format('YYYY-MM-DD')
      : undefined
    item.progress = kr.progress
    item.kr.startDay = kr.start_day
    item.kr.finishDay = kr.finish_day
    item.kr.progress = kr.progress
  }
  editWeekVisible.value = true
}

// 编辑评论
const editCommentVisible = ref(false)
const weeklyDetail = ref(undefined)
const editCommentHandler = (record, column) => {
  const week = column.split(':')[1]
  weeklyDetail.value = record.week[week]
  editCommentVisible.value = true
}

// 编辑o的产出描述
const editObjectiveDescVisible = ref(false)
const objectiveDesc = ref('[]')
const objectiveId = ref(undefined)
const updateObjectiveDescription = ref(undefined)
const editObjectiveDescHander = (record, text) => {
  if (props.userId) {
    return
  }
  objectiveId.value = record.objectiveId
  objectiveDesc.value = record.objectiveDescription
  updateObjectiveDescription.value = (val) => {
    record.objectiveDescription = val
  }
  editObjectiveDescVisible.value = true
}

// get content
const parseContent = (column, record) => {
  return replaceStr2Html((column.split(':').reduce((pre, cur) => pre[cur] || '-', record)) || '')
}

</script>
<style lang="less" scoped>
.table {
  height: calc(100vh - 48px - 56px);
}

.content {
  min-height: 100%;
  // &:hover {
  //   background: #fafafa;
  // }
}

.comment-button {
  color: #0085FF;
  cursor: pointer;
}
</style>
